import React, { useEffect, useState } from "react";

const apiFetch = (url, csrfToken, options = {}) => {
  return fetch(url, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "CSRF-Token": csrfToken,
      ...options.headers
    },
    ...options
  });
};

export default function Admin() {
    const [athletes, setAthletes] = useState([]);
    const [csrfToken, setCsrfToken] = useState(null);

    useEffect(() => {
        // otherwise just fetch athletes
        fetch(`${process.env.REACT_APP_BACKEND_URL}/athletes`,
            {
                credentials: "include"
            }
        )
            .then(r => r.json())
            .then(setAthletes);
    }, []);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`, {
            credentials: "include"
        })
            .then(r => r.json())
            .then(data => setCsrfToken(data.csrfToken));
    }, []);

    const sync = (id) => {
        apiFetch(`${process.env.REACT_APP_BACKEND_URL}/athletes/${id}/sync`, csrfToken, {
            method: "POST"
        });
    };

    return (
        <div>
            <h1>Admin</h1>

            {athletes.length > 0 ? (
                athletes.map(a => (
                    <div key={a._id}>
                        {a.name}
                        <button onClick={() => sync(a._id)}>Sync</button>
                    </div>
                ))
            ) : (
                <p>No athletes found.</p>
            )}
        </div>
    );
}